import './ccf-agent-leg-dialing-icon.module.scss';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Component used to display agent leg dialing icon
 * @param props - SvgIconProps
 * @example - <CcfAgentLegDialingIcon />
 * @returns SVG of agent leg dialing Icon
 */
export function CcfAgentLegDialingIcon(props: SvgIconProps) {
  return (
    <SvgIcon viewBox="0 0 32 24" {...props}>
      <g id="agent-leg-connecting" transform="translate(0)">
        <path
          id="Path_30421"
          data-name="Path 30421"
          d="M17.813,6.663H16.1a2.706,2.706,0,0,1-2.74,2.261H4.487A2.706,2.706,0,0,1,1.713,6.217V4.5A2.706,2.706,0,0,1,4.487,1.713H13.36a2.672,2.672,0,0,1,1.422.411h2.347A4.47,4.47,0,0,0,13.36,0H4.487A4.487,4.487,0,0,0,0,4.487V6.2a4.487,4.487,0,0,0,4.487,4.5H13.36a4.47,4.47,0,0,0,4.453-4.042Z"
          fill={props.fill}
        />
        <path
          id="Path_30422"
          data-name="Path 30422"
          d="M23.727,8.29V6.577A4.487,4.487,0,0,0,19.24,2.09H10.368A4.47,4.47,0,0,0,6,6.1H7.713a2.706,2.706,0,0,1,2.655-2.227H19.24a2.706,2.706,0,0,1,2.689,2.706V8.29a2.706,2.706,0,0,1-2.706,2.723H10.368A2.689,2.689,0,0,1,8.895,10.5H6.5a4.47,4.47,0,0,0,3.854,2.227h8.872a4.487,4.487,0,0,0,4.5-4.436Z"
          transform="translate(4.277 1.49)"
          fill={props.fill}
        />
      </g>
    </SvgIcon>
  );
}

export default CcfAgentLegDialingIcon;
